import { Position } from '@xyflow/react';
import { ERFElement } from '../../../enums';
import { L_FLOW_HEX, M_FLOW_HEX } from '../../../constants';
export const SPLITTER_CONFIG = {
    type: ERFElement.Splitter,
    icon: 'Splitter_2d',
    templates: [
        {
            code: 'default',
            ports: [
                {
                    id: 'target_material_flow',
                    type: 'target',
                    name: 'Входной материальный поток',
                    position: Position.Left,
                    style: { top: 35, left: 12, background: M_FLOW_HEX },
                    connectionCount: 1
                },
                {
                    id: 'source_material_flows',
                    type: 'source',
                    name: 'Выходные материальные потоки',
                    position: Position.Right,
                    style: { top: 35, right: 13, background: M_FLOW_HEX },
                    connectionCount: Number.MAX_SAFE_INTEGER
                },
                /* PORTS FOR LOGICAL ELEMENTS */
                {
                    id: 'target_logical_flow',
                    type: 'target',
                    name: 'Входные параметры',
                    position: Position.Left,
                    style: { top: 50, left: 31, background: L_FLOW_HEX },
                    connectionCount: Number.MAX_SAFE_INTEGER
                },
                {
                    id: 'source_logical_flow',
                    type: 'source',
                    name: 'Выходные параметры',
                    position: Position.Right,
                    style: { top: 50, right: 13, background: L_FLOW_HEX },
                    connectionCount: Number.MAX_SAFE_INTEGER
                }
            ]
        }
    ]
};
//# sourceMappingURL=RFSplitterNode.config.js.map